// A súgó Markdownjába illesztett CobraConto.Net menüpont-linkek
// ("[Felirat](ccnl://<base64>)") DOM nélküli magja. A formátum a programé
// (Desktop\CobraContoNet\src\Conto\Util\CobraContoNetLink.cs): a "ccnl://"
// után a "type=ActivityGuid&guid=<menüpont GUID>" UTF-8 szöveg szabványos
// base64-e, a GUID a program Navigator.xml-jének "Guid"-ja. Szerver és
// katalógus nélküli linket a program a már futó, bejelentkezett példányban
// nyit meg — a súgóba ezért csak a típus és a GUID kerülhet: a renderelő
// ebből a kettőből építi újra a linket, a ../validate-data.mjs pedig hibának
// jelzi, ha a forrásban más is van.
//
// Hárman használják: az app.ts (gombbá alakítás), a ../validate-data.mjs
// (tartalom-ellenőrzés) és a tesztek. A search.ts-hez hasonlóan nincs
// relatív importja, és csak "törölhető" TS-szintaxist használ, így a Node
// közvetlenül betölti.
export const CCNL_SCHEME = "ccnl://";
const activityLinkType = "ActivityGuid";
// A program Convert.FromBase64String-je csak a szabványos ábécét és a teljes
// kitöltést ("=") fogadja el — a böngésző atob()-ja ennél engedékenyebb.
const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// Csak a sémát nézi, az érvényességet nem: a HTML-tisztító ezzel engedi át a
// href-et (a "ccnl:" séma a böngészőben nem futtatható), a hibás linket a
// renderelő alakítja sima szöveggé.
export function isCcnlHref(href) {
    return /^ccnl:/i.test(href.trim());
}
export function buildCcnlActivityHref(guid) {
    return CCNL_SCHEME + btoa(`type=${activityLinkType}&guid=${guid.toLowerCase()}`);
}
export function parseCcnlLink(href) {
    const value = href.trim();
    if (!value.toLowerCase().startsWith(CCNL_SCHEME)) {
        return { ok: false, error: `nem "${CCNL_SCHEME}" kezdetű` };
    }
    // A böngésző a végére tehet egy "/"-t — a program is levágja.
    const payload = value.slice(CCNL_SCHEME.length).replace(/\/$/, "");
    if (payload === "" || !base64Pattern.test(payload)) {
        return { ok: false, error: "a törzse nem szabványos, kitöltött base64" };
    }
    let query;
    try {
        const bytes = Uint8Array.from(atob(payload), (character) => character.charCodeAt(0));
        query = new TextDecoder("utf-8", { fatal: true }).decode(bytes);
    }
    catch {
        return { ok: false, error: "a törzse nem UTF-8 szöveg" };
    }
    const params = new URLSearchParams(query);
    const type = params.get("type") ?? "";
    if (type.toLowerCase() !== activityLinkType.toLowerCase()) {
        return { ok: false, error: `csak menüpont-link (type=${activityLinkType}) használható, ez: type=${type || "(nincs)"}` };
    }
    const guid = params.get("guid") ?? "";
    if (!guidPattern.test(guid)) {
        return { ok: false, error: `érvénytelen menüpont-GUID: ${guid || "(nincs)"}` };
    }
    return {
        ok: true,
        link: {
            guid: guid.toLowerCase(),
            href: buildCcnlActivityHref(guid),
            hasServerOrCatalog: Boolean(params.get("server") || params.get("catalog")),
        },
    };
}
